import { useCallback } from "react";
import { useToast } from "./use-toast";

export function useNotification() {
  const { toast, success, error, warning, info, loading, dismiss } = useToast();

  const notify = useCallback(
    (message: string, type: string = "info", options: any = {}) => {
      const { title, variant, showProgress, duration, ...rest } = options;

      switch (type) {
        case "success":
          return success(title || message, message, {
            variant: "success",
            showProgress,
            duration,
            ...rest,
          });
        case "error":
          return error(title || message, message, {
            variant: "error",
            showProgress,
            duration,
            ...rest,
          });
        case "warning":
          return warning(title || message, message, {
            variant: "warning",
            showProgress,
            duration,
            ...rest,
          });
        case "info":
        default:
          return info(title || message, message, {
            variant: "info",
            showProgress,
            duration,
            ...rest,
          });
      }
    },
    [success, error, warning, info],
  );

  return {
    notify,
    success,
    error,
    warning,
    info,
    loading,
    dismiss,
    toast,
  };
}
